/** @format */

import React, { Component } from 'react';
import {
  Segment,
  Form,
  Header,
  Grid,
  Container,
  Image,
  Divider,
} from 'semantic-ui-react';
import { auth } from '../../firebase/config';
import Logo from '../../public/images/logo.png';

import './login.css';

class Login extends Component {
  state = {
    user: {
      email: '',
      password: '',
    },
    validation: {
      email: false,
      password: false,
    },
  };

  login() {
    let $this = this;
    const email = this.state.user.email;
    const password = this.state.user.password;
    auth
      .signInWithEmailAndPassword(email, password)
      .then(function (data) {
        // console.log(data.user.uid);
      })
      .catch(function (error) {
        var errorCode = error.code;
        if (errorCode === 'auth/invalid-email') {
          $this.validation('email');
        }
        if (errorCode === 'auth/wrong-password') {
          $this.validation('password');
        }
        if (errorCode === 'auth/user-not-found') {
          $this.validation('email');
        }
      });
  }

  validation = name => {
    let validation = { ...this.state.validation };
    validation[name] = true;
    this.setState({ validation });
  };

  handleLoginInput = input => {
    let user = { ...this.state.user };
    const name = input.name;
    const value = input.value;
    user[name] = value;
    this.setState({ user });
  };

  render() {
    return (
      <Container>
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={3} computer={5} />
            <Grid.Column mobile={16} tablet={10} computer={6}>
              <Segment className="login-segment headed-segment">
                <div className="segment-header login-header">
                  <Grid>
                    <Grid.Row columns="2">
                      <Grid.Column>
                        <Header as="h4">Login</Header>
                      </Grid.Column>
                      <Grid.Column>
                        <Image src={Logo} />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </div>
                <Form size="tiny" onSubmit={() => this.login()}>
                  <Form.Input
                    autoComplete="username"
                    error={this.state.validation.email}
                    value={this.state.user.email}
                    onChange={(e, input) => this.handleLoginInput(input)}
                    placeholder="Email"
                    name="email"
                    type="text"
                    label="Email"
                  />
                  <Form.Input
                    error={this.state.validation.password}
                    value={this.state.user.password}
                    onChange={(e, input) => this.handleLoginInput(input)}
                    placeholder="Password"
                    autoComplete="current-password"
                    name="password"
                    type="password"
                    label="Passowrd"
                  />
                  <Divider />
                  <Form.Button color="green" type="submit" fluid>
                    Login
                  </Form.Button>
                </Form>
              </Segment>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={3} computer={5} />
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default Login;
